import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { Situations } from './components/Situations';
import { PackageContents } from './components/PackageContents';
import { PagePreview } from './components/PagePreview';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-cream-100" data-id="element-0" data-mp="2wjqgz5t882m4">
      <AnnouncementBar data-id="element-1" data-mp="2whxcnx635uha" />
      <main data-id="element-2" data-mp="28u5zkrcq1dey">
        <Hero data-id="element-3" data-mp="28tw972nrl48q" />
        <StatsBar data-id="element-4" data-mp="28te3lff7pdo5" />
        <Transformation data-id="element-5" data-mp="28suv0pbgc1ms" />
        <Situations data-id="element-6" data-mp="28s2zfehuu3wi" />
        <PackageContents data-id="element-7" data-mp="23vktwcepa1j4" />
        <PagePreview data-id="element-8" data-mp="23u9v6r043jyv" />
        <Bonuses data-id="element-9" data-mp="23ut9lxqjzq85" />
        <Offer data-id="element-10" data-mp="23t8eo70bu59r" />
        <Guarantee data-id="element-11" data-mp="3ijxoypkvdyjd" />
        <Testimonials data-id="element-12" data-mp="3ikh5q2ysagvt" />
        <Faq data-id="element-13" data-mp="3ij66mgga9xb1" />
      </main>
      <Footer data-id="element-14" data-mp="3ihv2gfixenje" />
    </div>;
}